<div *ngIf="layoutType === 'leader' || layoutType === 'share'"
     [ngClass]="{
      'leader-container': (layoutType === 'leader') || isMobilePlatform || isMobileViewport,
      'share-container': (layoutType === 'share') && !isMobilePlatform && !isMobileViewport
      }"
>
  <div class="main" *ngIf="videosArrayLength && leader" [class.only]="videosArrayLength === 1">
    <thevatra-video [isHidden]="false"
                    [source]="leader.video">
      <thevatra-zwift-screenshare *ngIf="leader.zwiftScreen"
                                  [source]="leader.zwiftScreen">
      </thevatra-zwift-screenshare>
    </thevatra-video>
  </div>
  <div class="others"
       [class.hidden]="(othersArrayLength === 0)"
       [class.expanded]="isSticky"
       [class.visible]="true"
  >
    <div class="scroll scroll-left"
         *ngIf="customConfig.isLikesEnabled"
         [class.hidden]="(0 > startIndex - 1)"
         (click)="showPrev($event)"
    >
      <stusan-icon icon="arrow"></stusan-icon>
    </div>
    <div class="viewport" #sourceWrapper cdkScrollable [ngClass]="'lt-four'"
         (cdkObserveContent)="othersChanged($event)" [debounce]="100"
         [cdkObserveContentDisabled]="othersArrayLength < 5">
      <div class="scroll more"
           *ngIf="othersArrayLength > 3"
      >
        <span class="more__inner"
              (click)="seeMore($event)"
        >
          <ng-container *ngIf="((videosArray.length - othersArray.length - 1) <= 0); else others">
            Show <br> less
          </ng-container>
          <ng-template #others>
            +{{ pluralize(videosArray.length - othersArray.length - 1, 'other') }}
          </ng-template>
        </span>
      </div>
      <ng-container *ngFor="let source of othersArray; index as i; trackBy: trackByVideoFn">
        <thevatra-video *ngIf="source?.visible"
                        [isHidden]="false"
                        [class.invisible]="i < startIndex || i > endIndex"
                        [source]="source.video"
                        (click)="setLeader(source.video, true, $event)"
                        layoutName="other">
          <thevatra-zwift-screenshare *ngIf="source.zwiftScreen"
                                      [source]="source.zwiftScreen">
          </thevatra-zwift-screenshare>
        </thevatra-video>
      </ng-container>
    </div>
    <div class="scroll scroll-right"
         *ngIf="customConfig.isLikesEnabled"
         [class.hidden]="othersArrayLength <= endIndex + 1"
         (click)="showNext($event)">
      <stusan-icon icon="arrow"></stusan-icon>
    </div>
  </div>
</div>
<div *ngIf="layoutType === 'tile'" thevatraDynamicTiles class="tiles-container">
  <ng-container *ngFor="let source of videosArray; index as v; trackBy: trackByVideoFn">
    <thevatra-video #other
                    #tile
                    [isHidden]="false"
                    *ngIf="source.visible"
                    [source]="source.video">
      <thevatra-zwift-screenshare *ngIf="source.zwiftScreen"
                                  [source]="source.zwiftScreen">
      </thevatra-zwift-screenshare>
    </thevatra-video>
  </ng-container>
  <div #tile
       class="others"
       *ngIf="videosArray.length > tileItemsOnScreen"
       (click)="stateService.isParticipantsShown = true"
  >
    <div class="others__inner">
      +{{ pluralize(videosArray.length - 8, 'participant') }}
    </div>
  </div>
</div>

<!-- Audio subscriptions -->
<div>
  <ng-container *ngFor="let source of videosArray; index as i; trackBy: trackByAudioFn">
    <audio *ngIf="hasAudioAndNotLocal(source)" [srcObject]="source.audio?.stream" autoplay playsinline></audio>
  </ng-container>
</div>

<thevatra-participants [videos]="janusService.videos$ | async"></thevatra-participants>
<stusan-chat></stusan-chat>
